export default __webpack_public_path__ + "70fdf7fc959dbc9ac69ef0ee00810146.woff";